// ** Navigation imports
import {
    PieChart
} from "react-feather";

import Setup from './setup';
import Report from "./Report";
import Entry from "./Entry";
export default [

  ...Entry,
  ...Setup,
  ...Report
];
